import script from "./DeleteConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=588ef8a3&scoped=true&lang=css"
import "./DeleteConfirmationModal.vue?vue&type=style&index=1&id=588ef8a3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588ef8a3"]])

export default __exports__